import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { applyNativePlatformClass } from "./lib/platform/native-class.ts";
import { getSupabaseClient } from "./lib/supabase/client.ts";
import "./styles/global.css";

/* Gate CSS natif (classe `is-native` sur <html>) — synchrone, avant le rendu :
   la vitre .statusbar-scrim est active dès le premier paint, sans flash. */
applyNativePlatformClass();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

createRoot(rootElement).render(
  <StrictMode>
    <App client={getSupabaseClient()} />
  </StrictMode>,
);
